document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

const mobileMedia = window.matchMedia('(max-width: 920px)');

const setMenuOpen = (open) => {
  document.body.classList.toggle('menu-open', open);
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-mobile-nav]');
  if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  if (nav) nav.setAttribute('aria-hidden', open ? 'false' : 'true');
  if (!open) {
    document.querySelectorAll('.has-mega.is-open').forEach((item) => {
      item.classList.remove('is-open');
      item.querySelector('[data-nav-expand]')?.setAttribute('aria-expanded', 'false');
    });
  }
  if (open) setCartOpen(false);
};

const setCartOpen = (open) => {
  const drawer = document.querySelector('[data-cart-drawer]');
  document.body.classList.toggle('cart-open', open);
  if (!drawer) return;
  drawer.classList.toggle('is-open', open);
  drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
  if (open) setMenuOpen(false);
};

const setSearchOpen = (open) => {
  const drawer = document.querySelector('[data-search-drawer]');
  document.body.classList.toggle('search-open', open);
  if (!drawer) return;
  drawer.classList.toggle('is-open', open);
  drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
  if (open) {
    setMenuOpen(false);
    setCartOpen(false);
    requestAnimationFrame(() => drawer.querySelector('[data-search-input]')?.focus());
  }
};

const updateCartCount = (count) => {
  document.querySelectorAll('[data-cart-count]').forEach((badge) => {
    badge.textContent = String(count);
    badge.hidden = count <= 0;
  });
  const countEl = document.querySelector('[data-cart-drawer-count]');
  if (countEl) {
    if (count <= 0) {
      countEl.hidden = true;
      countEl.textContent = '';
    } else {
      countEl.hidden = false;
      countEl.textContent = count === 1 ? '1 item' : `${count} items`;
    }
  }
  const footer = document.querySelector('[data-cart-drawer-footer]');
  if (footer) footer.hidden = count <= 0;
  const titleEl = document.querySelector('[data-cart-drawer-title]');
  if (titleEl) {
    titleEl.textContent = count <= 0 ? 'Your cart is empty' : count === 1 ? 'Your cart · 1 item' : `Your cart · ${count} items`;
  }
};

const showThemeToast = (message) => {
  let toast = document.querySelector('[data-theme-toast]');
  if (!toast) {
    toast = document.createElement('div');
    toast.className = 'theme-toast';
    toast.setAttribute('data-theme-toast', '');
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    document.body.appendChild(toast);
  }
  toast.textContent = message;
  toast.classList.add('is-visible');
  window.clearTimeout(showThemeToast._timer);
  showThemeToast._timer = window.setTimeout(() => toast.classList.remove('is-visible'), 2600);
};

const getCartSectionId = () => {
  const drawer = document.querySelector('[data-cart-drawer]');
  const sectionEl = drawer?.closest('.shopify-section, [id^="shopify-section-"]');
  return sectionEl?.id?.replace('shopify-section-', '') || 'cart-drawer';
};

const refreshCartDrawer = async () => {
  const body = document.querySelector('[data-cart-drawer-body]');
  if (!body) return null;
  const root = window.Shopify?.routes?.root || '/';
  const res = await fetch(`${root}?sections=${encodeURIComponent(getCartSectionId())}`);
  if (!res.ok) return null;
  const sections = await res.json();
  const html = sections[getCartSectionId()] || sections['cart-drawer'];
  if (!html) return null;
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const next = doc.querySelector('[data-cart-drawer-body]');
  if (next) body.innerHTML = next.innerHTML;
  const cartRes = await fetch('/cart.js');
  if (!cartRes.ok) return null;
  const cart = await cartRes.json();
  updateCartCount(cart.item_count);
  return cart;
};

const changeCartLine = async (line, quantity) => {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ line, quantity }),
  });
  await refreshCartDrawer();
};

document.addEventListener('click', (e) => {
  if (e.target.closest('[data-nav-expand]')) {
    e.preventDefault();
    const btn = e.target.closest('[data-nav-expand]');
    const item = btn?.closest('.has-mega');
    if (!item) return;
    const open = !item.classList.contains('is-open');
    item.closest('.nav-list')?.querySelectorAll('.has-mega.is-open').forEach((el) => {
      if (el !== item) {
        el.classList.remove('is-open');
        el.querySelector('[data-nav-expand]')?.setAttribute('aria-expanded', 'false');
      }
    });
    item.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    return;
  }
  if (e.target.closest('[data-menu-toggle]')) {
    setMenuOpen(!document.body.classList.contains('menu-open'));
    return;
  }
  if (e.target.closest('[data-search-toggle]')) {
    e.preventDefault();
    const d = document.querySelector('[data-search-drawer]');
    if (d) setSearchOpen(!d.classList.contains('is-open'));
    return;
  }
  if (e.target.closest('[data-cart-toggle]')) {
    e.preventDefault();
    const open = !document.querySelector('[data-cart-drawer]')?.classList.contains('is-open');
    if (open) refreshCartDrawer().finally(() => setCartOpen(true));
    else setCartOpen(false);
    return;
  }
  const qtyBtn = e.target.closest('[data-cart-qty-minus], [data-cart-qty-plus]');
  if (qtyBtn) {
    const line = Number(qtyBtn.dataset.line);
    const item = qtyBtn.closest('[data-cart-item]');
    const val = item?.querySelector('[data-cart-qty-value]');
    const cur = Math.max(0, parseInt(val?.textContent, 10) || 0);
    const next = Math.max(0, cur + (qtyBtn.hasAttribute('data-cart-qty-plus') ? 1 : -1));
    if (line) changeCartLine(line, next);
    return;
  }
  if (e.target.closest('[data-cart-remove]')) {
    const line = Number(e.target.closest('[data-cart-remove]')?.dataset.line);
    if (line) changeCartLine(line, 0);
  }
  if (e.target.closest('.primary-nav--mobile a') && mobileMedia.matches) {
    setMenuOpen(false);
  }
});

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    setMenuOpen(false);
    setCartOpen(false);
    setSearchOpen(false);
  }
});

const initReveal = () => {
  const els = document.querySelectorAll('[data-reveal]');
  if (!els.length) return;
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );
  els.forEach((el) => io.observe(el));
};

const initParallax = () => {
  const el = document.querySelector('[data-parallax]');
  if (!el || mobileMedia.matches) return;
  window.addEventListener(
    'scroll',
    () => {
      const y = window.scrollY * 0.06;
      el.style.transform = `translateY(${y}px)`;
    },
    { passive: true }
  );
};

const initSiteTopHeight = () => {
  const top = document.getElementById('site-top');
  if (!top) return;
  const set = () => document.documentElement.style.setProperty('--site-top-height', `${top.offsetHeight}px`);
  set();
  window.addEventListener('resize', set);
};

const formatMoney = (cents) => {
  const amount = Number(cents || 0) / 100;
  const currency = window.Shopify?.currency?.active || 'EUR';
  const locale = document.documentElement.lang || 'en';

  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency,
      currencyDisplay: 'symbol',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  } catch (error) {
    return `${currency} ${amount.toFixed(2)}`;
  }
};

const readProductVariants = (form) => {
  try {
    return JSON.parse(form.querySelector('[data-product-variants]')?.textContent || '[]');
  } catch { return []; }
};

const getSelectedOptions = (form) =>
  [...form.querySelectorAll('.pdp-option')].map((fs) => fs.querySelector('input:checked')?.value || '');

const getFormVariant = (form, variants) => {
  const select = form.querySelector('[data-variant-select]');
  if (!select || !variants.length) return null;
  if (select.tagName === 'SELECT') {
    const opts = getSelectedOptions(form);
    if (opts.some(Boolean)) {
      const m = variants.find((v) => opts.every((val, i) => !val || v.options[i] === val));
      if (m) return m;
    }
  }
  return variants.find((v) => String(v.id) === String(select.value)) || variants[0];
};

const setProductButtonState = (form, variant, state = 'available') => {
  const btn = form.querySelector('[data-add-button]');
  const label = form.querySelector('[data-add-label]');
  const available = btn?.getAttribute('data-available-label') || 'Add to bag';
  const soldOut = btn?.getAttribute('data-soldout-label') || 'Sold out';
  const ok = state === 'available' && variant?.available;
  if (btn) btn.disabled = !ok;
  const bottomAdd = document.querySelector('.pdp-mobile-bar [data-sticky-add]');
  if (bottomAdd) { bottomAdd.disabled = !ok; bottomAdd.textContent = state === 'unavailable' ? 'UNAVAILABLE' : (ok ? 'ADD TO CART' : 'SOLD OUT'); }
  if (label) label.textContent = state === 'unavailable' ? 'Unavailable' : (ok ? available : soldOut);
    const stickyButton = form.closest('.pdp')?.querySelector('.pdp-mobile-bar__button');
    if (stickyButton) { stickyButton.disabled = !ok; stickyButton.textContent = state === 'unavailable' ? 'UNAVAILABLE' : (ok ? available : soldOut); }
  const price = variant ? formatMoney(variant.price) : '';
  const compare = '';
  const pdp = form.closest('.pdp');
  if (price) {
    pdp?.querySelectorAll('[data-product-price]').forEach((el) => { el.textContent = price; });
    const priceButtons = form.closest('.pdp')?.querySelectorAll('[data-product-price-button]') || [];
    priceButtons.forEach((element) => { element.textContent = price; });
    const sp = document.querySelector('[data-sticky-price]');
    if (sp) sp.textContent = price;
  }
  pdp?.querySelectorAll('[data-product-compare]').forEach((el) => {
    if (compare) { el.textContent = compare; el.hidden = false; }
    else { el.hidden = true; }
  });
  const skuEl = pdp?.querySelector('.pdp-buybox__sku');
  if (skuEl && variant?.sku) skuEl.textContent = `SKU · ${variant.sku}`;
};

const updateProductForm = (form) => {
  const variants = readProductVariants(form);
  if (!variants.length) return;
  const variant = getFormVariant(form, variants);
  const select = form.querySelector('[data-variant-select]');
  if (!variant) {
    setProductButtonState(form, null, 'unavailable');
    document.querySelectorAll('[data-buy-now]').forEach((buyNow) => { buyNow.setAttribute('aria-disabled', 'true'); buyNow.tabIndex = -1; });
    return;
  }
  if (select?.tagName === 'SELECT') select.value = String(variant.id);
  setProductButtonState(form, variant, variant.available ? 'available' : 'soldout');
  document.querySelectorAll('[data-buy-now]').forEach((buyNow) => {
    buyNow.href = `${window.Shopify?.routes?.root || '/'}cart/${variant.id}:${Math.max(1, Number.parseInt(form.querySelector('[data-qty-input]')?.value, 10) || 1)}`;
    buyNow.setAttribute('aria-disabled', variant.available ? 'false' : 'true');
    buyNow.tabIndex = variant.available ? 0 : -1;
  });
  const preview = document.querySelector('[data-pdp-gallery] [data-variant-preview] img');
  const thumb = document.querySelector('[data-pdp-gallery] [data-variant-thumb] img');
  const src = variant.featured_image?.src;
  if (preview && src) {
    preview.src = src;
    preview.srcset = '';
    preview.alt = variant.title;
    if (thumb) { thumb.src = src; thumb.srcset = ''; }
    const gallery = preview.closest('[data-pdp-gallery]');
    if (gallery) goToPdpSlide(gallery, 0);
  }
};

const handleProductFormSubmit = async (event) => {
  const form = event.currentTarget?.matches?.('form') ? event.currentTarget : event.target?.closest('form');
  if (!form?.closest('[data-pdp]')) return;
  event.preventDefault();
  event.stopPropagation();
  const btn = form.querySelector('[data-add-button]');
  if (btn?.disabled || form.dataset.cartSubmitting === 'true') return;
  const variant = getFormVariant(form, readProductVariants(form));
  if (!variant) return;
  form.dataset.cartSubmitting = 'true';
  btn.disabled = true;
  try {
    const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variant.id), quantity: Number(form.querySelector('[data-qty-input]')?.value || 1) }] }),
    });
    if (!res.ok) throw new Error('Add failed');
    await refreshCartDrawer();
    const cart = await fetch('/cart.js').then((r) => r.json());
    updateCartCount(cart.item_count);
    showThemeToast('Added to cart');
    if (form.dataset.afterAdd !== 'stay') setCartOpen(true);
  } catch (e) {
    if (console.error) console.error(e);
  } finally {
    form.dataset.cartSubmitting = 'false';
    btn.disabled = !variant.available;
  }
};

const goToPdpSlide = (gallery, index) => {
  const track = gallery.querySelector('[data-pdp-gallery-track]');
  const slides = track ? [...track.querySelectorAll('.pdp-gallery__slide')] : [];
  if (!track || !slides[index]) return;
  track.scrollTo({ left: slides[index].offsetLeft, behavior: mobileMedia.matches ? 'smooth' : 'auto' });
  gallery.querySelectorAll('[data-pdp-thumb]').forEach((t, i) => t.classList.toggle('is-active', i === index));
  gallery.querySelectorAll('[data-pdp-gallery-dot]').forEach((d, i) => d.classList.toggle('is-active', i === index));
};

const initPdpGallery = () => {
  document.querySelectorAll('[data-pdp-gallery]').forEach((gallery) => {
    if (gallery.dataset.galleryReady) return;
    gallery.dataset.galleryReady = 'true';
    const track = gallery.querySelector('[data-pdp-gallery-track]');
    const slides = track ? [...track.querySelectorAll('.pdp-gallery__slide')] : [];
    if (!track || slides.length <= 1) return;
    const getIdx = () => Math.round(track.scrollLeft / (track.clientWidth || 1));
    track.addEventListener('scroll', () => {
      const i = getIdx();
      gallery.querySelectorAll('[data-pdp-thumb]').forEach((t, ti) => t.classList.toggle('is-active', ti === i));
      gallery.querySelectorAll('[data-pdp-gallery-dot]').forEach((d, di) => d.classList.toggle('is-active', di === i));
    }, { passive: true });
    gallery.querySelector('[data-pdp-gallery-prev]')?.addEventListener('click', () => goToPdpSlide(gallery, Math.max(0, getIdx() - 1)));
    gallery.querySelector('[data-pdp-gallery-next]')?.addEventListener('click', () => goToPdpSlide(gallery, Math.min(slides.length - 1, getIdx() + 1)));
    gallery.querySelectorAll('[data-pdp-thumb]').forEach((t) => t.addEventListener('click', () => goToPdpSlide(gallery, Number(t.dataset.pdpThumb || 0))));
    gallery.querySelectorAll('[data-pdp-gallery-dot]').forEach((d) => d.addEventListener('click', () => goToPdpSlide(gallery, Number(d.dataset.pdpGalleryDot || 0))));
  });
};

const initStickyProductBar = () => {
  const actions = document.querySelector('[data-pdp-actions]');
  const sticky = document.querySelector('[data-pdp-sticky]');
  if (!actions || !sticky || !mobileMedia.matches) { if (sticky) sticky.hidden = true; return; }
  sticky.hidden = false;
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(([e]) => {
      document.body.classList.toggle('pdp-sticky-visible', !e.isIntersecting);
    }, { threshold: 0 }).observe(actions);
  }
};

const initProductPage = () => {
  document.querySelectorAll('[data-product-form]').forEach((form) => {
    if (form.dataset.submitReady) return;
    form.dataset.submitReady = 'true';
    form.addEventListener('submit', handleProductFormSubmit, true);
    updateProductForm(form);
  });
  document.querySelectorAll('[data-buy-now]').forEach((link) => {
    if (link.dataset.buyNowReady) return;
    link.dataset.buyNowReady = 'true';
    link.addEventListener('click', (event) => {
      const form = link.closest('.pdp')?.querySelector('[data-product-form]') || document.querySelector('[data-pdp] [data-product-form]');
      const variant = form && getFormVariant(form, readProductVariants(form));
      if (!variant?.available) { event.preventDefault(); return; }
      const quantity = Math.max(1, Number.parseInt(form.querySelector('[data-qty-input]')?.value, 10) || 1);
      link.href = `${window.Shopify?.routes?.root || '/'}cart/${variant.id}:${quantity}`;
    });
  });
  initPdpGallery();
  initStickyProductBar();
};

document.addEventListener('change', (e) => {
  if (e.target.closest('.pdp-option input')) {
    const form = e.target.closest('[data-product-form]');
    if (form) updateProductForm(form);
  }
});

document.addEventListener('click', (e) => {
  if (e.target.closest('[data-qty-minus], [data-qty-plus]')) {
    const wrap = e.target.closest('[data-qty]');
    const input = wrap?.querySelector('[data-qty-input]');
    if (!input) return;
    const n = Math.max(1, parseInt(input.value, 10) + (e.target.hasAttribute('data-qty-plus') ? 1 : -1));
    input.value = String(n);
  }
  if (e.target.closest('[data-sticky-add]')) {
    e.preventDefault();
    document.querySelector('[data-pdp] [data-add-button]')?.click();
  }
});

const initScrollHeader = () => {
  const top = document.getElementById('site-top');
  if (!top) return;
  const sync = () => top.classList.toggle('is-scrolled', window.scrollY > 8);
  sync();
  window.addEventListener('scroll', sync, { passive: true });
};

const initPdpIntro = () => {
  const intro = document.querySelector('.bulla-pdp-intro');
  if (!intro) return;
  const bg = intro.querySelector('.bulla-pdp-intro__bg');
  const onScroll = () => {
    const y = Math.min(window.scrollY, 400);
    intro.style.setProperty('--intro-scroll', String(y));
    if (bg) bg.style.opacity = String(1 - y / 500);
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
};

const initSmoothAnchors = () => {
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href^="#"]');
    if (!a || a.getAttribute('href') === '#') return;
    const id = a.getAttribute('href').slice(1);
    const target = document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
};

document.addEventListener('DOMContentLoaded', () => {
  initReveal();
  initParallax();
  initSiteTopHeight();
  initScrollHeader();
  initPdpIntro();
  initSmoothAnchors();
  initProductPage();
  const mobileNav = document.querySelector('[data-mobile-nav]');
  if (mobileNav?.closest('#site-top')) {
    const anchor = document.querySelector('[data-cart-drawer]') || document.getElementById('MainContent');
    const insertionPoint = anchor?.closest('body > *');
    if (insertionPoint?.parentNode === document.body) {
      document.body.insertBefore(mobileNav, insertionPoint);
    } else {
      document.body.appendChild(mobileNav);
    }
  }
});

document.addEventListener('shopify:section:load', () => {
  setMenuOpen(false);
  setCartOpen(false);
  setSearchOpen(false);
  initReveal();
  initPdpIntro();
  initProductPage();
});
